import React from "react";

import Routes from './pages/Routes';

const App = () => <Routes />;

export default App;
